<template>
    <report id="cta-personal">
        <page>
            <cover-page
                :reportType="$t(`reportsWeb.REPORT_TYPE`)"
                :firstName="reportData.firstName"
                :lastName="reportData.lastName"
                :date="dateCompleted"
                badge="BASIC"
            />
        </page>
        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.INTRODUCTION_TITLE') }}</survey-title>
                <div v-html="sanitizeHtml($t(`reportsWeb.INTRODUCTION_TEXT`))"></div>
            </div>

            <div class="cta-summary">
                <h2>{{ $t('reportsWeb.SUMMARY_TITLE') }}</h2>
                <div class="cta-summary-pages" v-html="sanitizeHtml($t(`reportsWeb.SUMMARY_TEXT`))"></div>
            </div>

            <div class="cta-overview-contents">
                <span class="cta-report-level">BASIC</span>
                <hr />
                <h2>Report Content</h2>
                <ul class="cta-report-content">
                    <li><span>{{ $t('reportsWeb.METHOD_TITLE') }}</span><span>2</span></li>
                    <li class="is-included"><span>{{ $t('reportsWeb.PROFILE_TITLE') }}</span></li>
                    <li><span>{{ $t('reportsWeb.UNDERSTANDING_TITLE') }}</span><span>3</span></li>
                    <li><span>{{ $t('reportsWeb.ACTION_DOMAIN_TITLE') }}</span><span>4</span></li>
                    <li class="is-included"><span>{{ $t('reportsWeb.OPERATING_DOMAIN_TITLE') }}</span></li>
                    <li class="is-included"><span>{{ $t('reportsWeb.ATTENTION_DOMAIN_TITLE') }}</span></li>
                    <li class="is-included"><span>{{ $t('reportsWeb.IMPLICATIONS_TITLE') }}</span></li>
                </ul>
                <p class="cta-overview-note">Sections in grey are included in the Standard (full) CTA Individual Report.</p>
            </div>
        </page>

        <page>
            <div>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.METHOD_TITLE') }}</survey-title>
                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_TEXT`))"></div>

                <div class="cta-about-domain-grid">
                    <div class="cta-about-domain-card is-active">
                        <h2>{{ $t('reportsWeb.ACTION_DOMAIN_TITLE') }}</h2>
                        <p>{{ $t('reportsWeb.ACTION_DOMAIN_TEXT') }}</p>
                        <div class="extended-action-domain">
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Move.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_MOVE`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Follow.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_FOLLOW`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Oppose.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_OPPOSE`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Bystand.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ACTION_DOMAIN_BYSTAND`))"></div>
                            </div>
                        </div>
                    </div>

                    <div class="cta-about-domain-card is-inactive">
                        <h2>{{ $t('reportsWeb.OPERATING_DOMAIN_TITLE') }}</h2>
                        <p>{{ $t('reportsWeb.OPERATING_DOMAIN_TEXT') }}</p>
                        <div class="extended-domain-operating">
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Closed.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_OPERATING_DOMAIN_CLOSED`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Open.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_OPERATING_DOMAIN_OPEN`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Random.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_OPERATING_DOMAIN_RANDOM`))"></div>
                            </div>
                        </div>
                    </div>

                    <div class="cta-about-domain-card is-inactive">
                        <h2>{{ $t('reportsWeb.ATTENTION_DOMAIN_TITLE') }}</h2>
                        <p>{{ $t('reportsWeb.ATTENTION_DOMAIN_TEXT') }}</p>
                        <div class="extended-domain-attention">
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Affect.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ATTENTION_DOMAIN_AFFECT`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Meaning.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ATTENTION_DOMAIN_MEANING`))"></div>
                            </div>
                            <div class="extended-domain-item">
                                <img src="/images/design/cta/Power.svg" alt="" />
                                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_ATTENTION_DOMAIN_POWER`))"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="cta-about-domain-tiers">
                    <span class="cta-report-level">BASIC</span>
                    <span class="cta-report-level is-included">Included in the Standard (full) report</span>
                    <span class="cta-report-level is-included">Included in the Standard (full) report</span>
                </div>

                <div v-html="sanitizeHtml($t(`reportsWeb.METHOD_TEXT_OUTRO`))"></div>
            </div>
        </page>

        <page>
            <div>
                <span class="cta-section-level">BASIC</span>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.UNDERSTANDING_TITLE') }}</survey-title>
                <div v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_TEXT`))"></div>
                <div class="chart-wrapper" style="margin-top: 2rem">
                    <CtaSunburstChart
                        :chartId="99"
                        :domainArray="generalArray"
                        :domainPreferred="[reportData.actionPreferred]"
                        forceBigOverlay
                    />
                    <div class="chart-text">
                        <div class="chart-text-understanding">
                            <div v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_CHART_EXPLAINER`))"></div>
                        </div>
                    </div>
                </div>
                <h3 class="paragraph-header">{{ $t('reportsWeb.UNDERSTANDING_GENERAL_TITLE') }}</h3>
                <div v-html="sanitizeHtml($t(`reportsWeb.UNDERSTANDING_GENERAL_EXPLAINER`))"></div>
            </div>
        </page>
        <page>
            <div>
                <span class="cta-section-level">BASIC</span>
                <survey-title class="cta-title" size="xl">{{ $t('reportsWeb.ACTION_DOMAIN_TITLE') }}</survey-title>
                <div class="chart-wrapper">
                    <CtaSunburstChart
                        :chartId="1"
                        class="action-domain-chart"
                        :domainArray="domainArray"
                        :domainPreferred="[reportData.actionPreferred]"
                    />
                    <div class="chart-text">
                        <div class="chart-text-action-domain">
                            <p>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER`) }}</p>
                            <div class="d-flex align-items-center justify-content-center">
                                <p>
                                    <b>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER_DEFAULT_TENDENCY_CALCULATED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.actionPreferred}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                    alt=""
                                />
                                <h2>{{ reportData.actionPreferred }}</h2>
                            </div>
                            <p>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER_2`) }}</p>
                            <div>
                                <p>
                                    <b>{{ $t(`reportsWeb.ACTION_DOMAIN_CHART_EXPLAINER_PREFERRED_PROPENSITY_REPORTED`) }}</b>
                                </p>
                                <img
                                    :src="`/images/design/cta/${reportData.actionReported}.svg`"
                                    style="width: 40px; height: 40px; margin-left: 0.5rem"
                                    alt=""
                                />
                                <h2>{{ reportData.actionReported }}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="extended-action-domain-wrapper">
                <div class="domain-item">
                    <img src="/images/design/cta/Move.svg" alt="" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_MOVE`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Follow.svg" alt="" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_FOLLOW`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Oppose.svg" alt="" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_OPPOSE`))"></div>
                </div>
                <div class="domain-item">
                    <img src="/images/design/cta/Bystand.svg" alt="" />
                    <div v-html="sanitizeHtml($t(`reportsWeb.ACTION_DOMAIN_BYSTAND`))"></div>
                </div>
            </div>
        </page>
    </report>
</template>
<script src="./CtaBasicReport.ts" />
<style lang="scss">
body.rendering {
    .cta-summary,
    .cta-overview-contents {
        display: block;
    }

    .cta-summary-pages {
        display: block;

        ul {
            list-style: none;
            padding-left: 3rem;
            padding-right: 3rem;
            margin-bottom: 2rem;

            li {
                max-width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 0.2rem;

                h3 {
                    margin: 0;
                }

                span {
                    font-weight: bold;
                }
            }
        }
    }
}

body:not(.rendering) {
    .cta-summary,
    .cta-overview-contents {
        display: none;
    }
}
</style>
